import { Box, Typography } from '@dtx-company/design-system/src'
import { CombinedTextProps } from '@dtx-company/shared-components/src/types/atoms'
import { ElementType, FC } from 'react'
import { JSXMapSerializer, PrismicRichText } from '@prismicio/react'
import { PrismicLinkSerializer } from '@app/prismic/src/components/PrismicLinkSerializer/PrismicLinkSerializer'
import { RichTextField } from '@prismicio/client'

type PrismicTextProps = {
  richTextField?: RichTextField
  as?: ElementType
} & CombinedTextProps

/**
 * Wrapper around our Text component to render text coming from Prismic with our
 * default styling and Text component API. It enables certain styling: bold,
 * italics and other nested tags to be respected when specified in Prismic.
 */
const PrismicText: FC<PrismicTextProps> = ({ richTextField, color, ...rest }) => {
  if (!richTextField) return null
  return (
    <Box
      sx={{
        color: color === 'primary.white' ? 'white' : 'black',
        maxWidth: rest.maxWidth,
        textAlign: rest.textAlign,
        mx: rest.mx as any
      }}
    >
      <PrismicRichText field={richTextField} components={serializer} />
    </Box>
  )
}
export const serializer: JSXMapSerializer = {
  hyperlink: PrismicLinkSerializer,
  paragraph: ({ children }) => <Typography>{children}</Typography>,
  heading1: ({ children }) => (
    <Typography variant={'headlineLarge'} component={'h1'}>
      {children}
    </Typography>
  ),
  heading2: ({ children }) => (
    <Typography variant={'headlineMedium'} component={'h2'} style={{ textAlign: 'center' }}>
      {children}
    </Typography>
  ),
  heading3: ({ children }) => (
    <Typography variant={'headlineSmall'} component={'h3'}>
      {children}
    </Typography>
  ),
  heading4: ({ children }) => <Typography variant={'headlineXSmall'}>{children}</Typography>
}

export default PrismicText
